import React from 'react';
import { FeaturedCard } from './FeaturedCard';
import styled from '@benzinga/themetron';
import { News, StoryObject } from '@benzinga/basic-news-manager';
import type { DeviceType } from '@benzinga/device-utils';

interface FeaturedSectionProps {
  nodes: StoryObject[] | News[];
  deviceType?: DeviceType;
}

export const FeaturedSectionIndia: React.FC<FeaturedSectionProps> = ({ nodes }) => {
  if (!nodes.length) return <div />;

  return (
    <FeaturedSectionWrapper className="top-section-container">
      <div className="desktop">
        <div className="top-story primary-story">
          <FeaturedCard
            fetchPriority="high"
            imagePreload={true}
            imageWidth={630}
            layout="india-primary"
            loading="eager"
            node={nodes[0]}
            relativePath={true}
          />
        </div>
        <div className="secondary-stories">
          <div className="secondary-story">
            {nodes.slice(1, 3).map((node, index) => (
              <FeaturedCard
                imagePreload={true}
                imageWidth={240}
                key={`featured-section-india-secondary-story-${index}`}
                layout="india-secondary"
                node={node}
                preloadOptions={{ media: '(min-width: 601px)' }}
                relativePath={true}
                size="compact"
              />
            ))}
          </div>
        </div>
      </div>

      <div className="mobile">
        <div className="list">
          {nodes.slice(0, 3).map((node, index) => (
            <div className="container">
              <FeaturedCard
                fetchPriority={index === 0 ? 'high' : 'low'}
                imagePreload={true}
                imageWidth={400}
                key={`featured-section-india-mobile-story-${index}`}
                layout="india-secondary"
                loading={index === 0 ? 'eager' : 'lazy'}
                node={node}
                preloadOptions={{ media: '(max-width: 600px)' }}
                relativePath={true}
              />
            </div>
          ))}
        </div>
      </div>
    </FeaturedSectionWrapper>
  );
};

const FeaturedSectionWrapper = styled.div`
  .desktop {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 280px auto;
    grid-gap: 20px;
    margin-bottom: -95px;

    .secondary-stories {
      display: grid;
      grid-template-columns: auto;
    }

    .primary-story {
      .post-card {
        height: 280px;
      }
      .post-card-text-wrapper {
        min-height: 5em;
      }

      @media screen and (max-width: 640px) {
        display: none;
      }
    }

    .secondary-story {
      display: grid;
      gap: 20px;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      margin: 0;

      .post-card {
        height: 200px;
      }
    }
    @media screen and (max-width: 640px) {
      display: none;
    }
    .mobile {
      display: none;
    }
  }

  .mobile {
    width: 100%;
    overflow-x: auto;
    .list {
      @media screen and (max-width: 640px) {
        height: 200px;
        width: 930px;
        border: none;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        .container {
          height: 200px;
          width: 300px;
          margin-right: 10px;
          .post-card {
            height: 200px;
          }
        }
      }
    }
  }
`;
